"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withThrottlingRouter = withThrottlingRouter;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var _tools = require("../tools");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Смотри описание {@link useThrottlingLocation}
 * @param Component
 */
function withThrottlingRouter(Component) {
  function WithThrottlingRouter(props) {
    var router = (0, _.useRouter)(false);

    var _useThrottlingLocatio = (0, _.useThrottlingLocation)(),
        _useThrottlingLocatio2 = _slicedToArray(_useThrottlingLocatio, 2),
        location = _useThrottlingLocatio2[0],
        onTransitionEnd = _useThrottlingLocatio2[1];

    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      router: router,
      onTransitionEnd: onTransitionEnd,
      routeState: location.state,
      location: location,
      route: location.route
    }));
  }

  WithThrottlingRouter.displayName = "WithThrottlingRouter(".concat((0, _tools.getDisplayName)(Component), ")");
  return WithThrottlingRouter;
}